import { render, staticRenderFns } from "./salesorderbycategory.vue?vue&type=template&id=368de6ae"
import script from "./salesorderbycategory.vue?vue&type=script&lang=js"
export * from "./salesorderbycategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports